import React from "react";
import PropTypes from "prop-types";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";

import { EXPANDABLE_LIST_ITEM_CLASS } from "../../../constants/ui";

const useStyles = makeStyles(theme => ({
  itemText: { paddingLeft: theme.spacing(2) },
}));

const expandable = open => {
  switch (open) {
    case true:
      return <ExpandLess />;
    case false:
      return <ExpandMore />;
    default:
      return null;
  }
};

const ExpandableButtonListItem = ({ title, open, icon, onClickHandler }) => {
  const classes = useStyles();
  return (
    <ListItem className={EXPANDABLE_LIST_ITEM_CLASS} button onClick={onClickHandler}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText className={classes.itemText} primary={title} />
      {expandable(open)}
    </ListItem>
  );
};

ExpandableButtonListItem.defaultProps = {
  icon: undefined,
  open: undefined,
};

ExpandableButtonListItem.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
  icon: PropTypes.object,
  onClickHandler: PropTypes.func.isRequired,
};

export default ExpandableButtonListItem;
